import { apiFetch } from './api';
import type { Project, ProjectGroup } from '@/deploy/types';

export interface ProjectCreatePayload {
  name: string;
  code: string;
  description?: string;
  color?: string;
  dotnetVersion?: string;
}

export interface ProjectUpdatePayload {
  name?: string;
  description?: string;
  color?: string;
  dotnetVersion?: string;
}

export const projectsService = {
  list: () => apiFetch<Project[]>('/api/projects'),
  /** GET individuel — inclut publicApiToken (backfilled si projet ancien). */
  get: (id: string) => apiFetch<Project>(`/api/projects/${id}`),
  create: (input: ProjectCreatePayload) =>
    apiFetch<Project>('/api/projects', { method: 'POST', json: input }),
  update: (id: string, patch: ProjectUpdatePayload) =>
    apiFetch<Project>(`/api/projects/${id}`, { method: 'PATCH', json: patch }),
  remove: (id: string) =>
    apiFetch<void>(`/api/projects/${id}`, { method: 'DELETE' }),
  /** Groupes de jeu du projet. Un CICD plus ancien répond 404 (route absente). */
  getGroups: (id: string) => apiFetch<ProjectGroup[]>(`/api/projects/${id}/groups`),
  /**
   * Remplace la liste. 400 clé invalide, en double ou réservée ; 409 {message, usedBy} si un
   * groupe retiré est encore réparti vers une autre instance que la Principale ou réglé sur
   * « Aucune » (usedBy[].instance = "_none") ; message composé par le CICD, affiché tel quel.
   */
  setGroups: (id: string, groups: ProjectGroup[]) =>
    apiFetch<ProjectGroup[]>(`/api/projects/${id}/groups`, { method: 'PUT', json: groups }),
};
